// extracted by mini-css-extract-plugin
export default {"text":"packageId-module__text__31V0J"};